import { render, staticRenderFns } from "./AppointmentUpdate.vue?vue&type=template&id=bf4a0166&"
import script from "./AppointmentUpdate.vue?vue&type=script&lang=js&"
export * from "./AppointmentUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports